/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const AdminPermission = {
    UsersRead: 'USERS_READ',
    UsersFull: 'USERS_FULL',
    LoadRead: 'LOAD_READ',
    LoadFull: 'LOAD_FULL',
    ManagersRead: 'MANAGERS_READ',
    ManagersFull: 'MANAGERS_FULL',
    CarrierRegistrationRead: 'CARRIER_REGISTRATION_READ',
    CarrierRegistrationFull: 'CARRIER_REGISTRATION_FULL',
    CarrierRegisteredRead: 'CARRIER_REGISTERED_READ',
    CarrierRegisteredFull: 'CARRIER_REGISTERED_FULL',
    CustomerRead: 'CUSTOMER_READ',
    CustomerFull: 'CUSTOMER_FULL',
    MapRead: 'MAP_READ'
} as const;
export type AdminPermission = typeof AdminPermission[keyof typeof AdminPermission];

